"use client";

import type { CreateToasterReturn } from "@chakra-ui/react";
import {
    Toaster as ChakraToaster,
    createToaster,
    Portal,
    Spinner,
    Stack,
    Toast,
} from "@chakra-ui/react";
import type * as toast from "@zag-js/toast";

export const toaster: CreateToasterReturn = createToaster({
    placement: "bottom-end",
    pauseOnPageIdle: true,
});

export const topToaster: CreateToasterReturn = createToaster({
    placement: "top",
    pauseOnPageIdle: true,
});

export const bottomToaster: CreateToasterReturn = createToaster({
    placement: "bottom",
    pauseOnPageIdle: true,
});

const renderToast = (toast: toast.Options<React.ReactNode>) => (
    <Toast.Root width={{ md: "sm" }}>
        {toast.type === "loading" ? (
            <Spinner size="sm" color="blue.solid" />
        ) : (
            <Toast.Indicator />
        )}
        <Stack gap="1" flex="1" maxWidth="100%">
            {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
            {toast.description && (
                <Toast.Description>{toast.description}</Toast.Description>
            )}
        </Stack>
        {toast.action && (
            <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
        )}
        {toast.meta?.closable && <Toast.CloseTrigger />}
    </Toast.Root>
);

export const Toaster = () => (
    <Portal>
        <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
            {renderToast}
        </ChakraToaster>
        <ChakraToaster toaster={topToaster} insetInline={{ mdDown: "4" }}>
            {renderToast}
        </ChakraToaster>
        <ChakraToaster toaster={bottomToaster} insetInline={{ mdDown: "4" }}>
            {renderToast}
        </ChakraToaster>
    </Portal>
);
